import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import AppWithAuth from './AppWithAuth.tsx';
import './index.css';
import { initSubscription } from './services/subscriptionService';

initSubscription();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppWithAuth />
  </StrictMode>
);
